import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../../store';
import { deleteMethod, get, post, put } from '../../../inteceptor';
import moment from 'moment';

const initialState = {
  error: null,
  time: null,
  data: [],
  addData: {},
  sorted: [],
  EnterPriceTypes: [],
};

const slice = createSlice({
  name: 'EnterPrices',
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = { message: action.payload, time: moment.now().toString() };
    },

    // GET EnterPriceManagement
    getAllEnterPriceTypesSuccess(state, action) {
      state.EnterPriceTypes = action.payload.data;
    },
    // GET EnterPriceManagement
    getEnterPricesSuccess(state, action) {
      state.data = action.payload.data;
    },

    addOrUpdateEnterPrices(state, action) {
      state.addData = {
        data: action.payload.data,
        time: moment.now().toString(),
      };
    },

    clearAll(state) {
      state.addData = {};
      state.error = {};
    },

    onBackStep(state) {
      state.checkout.activeStep -= 1;
    },

    onNextStep(state) {
      state.checkout.activeStep += 1;
    },

    onGotoStep(state, action) {
      const goToStep = action.payload;
      state.checkout.activeStep = goToStep;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { filterCategories } = slice.actions;

// ----------------------------------------------------------------------

export function getAllEnterPriceTypes() {
  return async () => {
    try {
      const response = await get(`allEnterPriceTypes`);
      if (response.status) {
        dispatch(slice.actions.getAllEnterPriceTypesSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getEnterPrices() {
  return async () => {
    try {
      const response = await get(`EnterPrice`);
      if (response.status) {
        dispatch(slice.actions.getEnterPricesSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function addEnterPrice(body) {
  return async () => {
    try {
      const response = await post(`EnterPrice`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateEnterPrices(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function addSupplierOrder(body) {
  return async () => {
    try {
      const response = await post(`SupplierOrder`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateEnterPrices(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function updateEnterPrice(body) {
  return async () => {
    try {
      const response = await put(`EnterPrice`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateEnterPrices(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function deleteEnterPrice(body) {
  return async () => {
    try {
      const response = await deleteMethod(`EnterPrice`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateEnterPrices(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
